// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIsCardedPropertyDto
 */
export interface IIsCardedPropertyDto {
    /**
     * 
     * @type {boolean}
     * @memberof IIsCardedPropertyDto
     */
    is_carded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IIsCardedPropertyDto
     */
    is_carded_state?: IIsCardedPropertyDtoIsCardedStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IIsCardedPropertyDtoIsCardedStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IIsCardedPropertyDto interface.
 */
export function instanceOfIIsCardedPropertyDto(value: object): value is IIsCardedPropertyDto {
    return true;
}

export function IIsCardedPropertyDtoFromJSON(json: any): IIsCardedPropertyDto {
    return IIsCardedPropertyDtoFromJSONTyped(json, false);
}

export function IIsCardedPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIsCardedPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'is_carded': json['is_carded'] == null ? undefined : json['is_carded'],
        'is_carded_state': json['is_carded_state'] == null ? undefined : json['is_carded_state'],
    };
}

export function IIsCardedPropertyDtoToJSON(json: any): IIsCardedPropertyDto {
    return IIsCardedPropertyDtoToJSONTyped(json, false);
}

export function IIsCardedPropertyDtoToJSONTyped(value?: IIsCardedPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_carded': value['is_carded'],
        'is_carded_state': value['is_carded_state'],
    };
}

